export default __webpack_public_path__ + "static/media/banner-1-title-icon.47a7c678.svg";